import React from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Problem from "@/components/landing/Problem";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import Market from "@/components/landing/Market";
import WhyUs from "@/components/landing/WhyUs";
import Pricing from "@/components/landing/Pricing";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F9F8F6] text-[#2B211A] selection:bg-[#8C735D] selection:text-[#F9F8F6]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Services />
        <Process />
        <Market />
        <WhyUs />
        <Pricing />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
